export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtInterier';
export const NAME = 'Interier';
